// ============================================================
// Prepared answer for the `carrier-brief` AI task (#73): talking
// points for the monthly meeting with a carrier, from the same
// numbers as the printable rating. Plain JS: the Worker imports it.
// Demo text is Czech or English; the AI writes in any language.
// ============================================================

const LIMIT = 15; // % no-shows without notice the plant tolerates
const r = (n) => (n == null ? '—' : Math.round(n));

export function carrierBriefDemo({ lang, carrier, now, prev }) {
  const cs = lang === 'cs';
  const name = carrier.name;
  const over = now.noShowPct >= LIMIT;
  const better = prev && now.noShowPct < prev.noShowPct;
  const slow = now.replyMedian != null && now.replyMedian > 30;

  const args = [
    cs ? `Nepřijetí bez avíza ${r(now.noShowPct)} % z ${now.loadings} nakládek${prev ? ` (předchozí měsíc ${r(prev.noShowPct)} %)` : ''}; limit závodu je ${LIMIT} %.`
       : `No-shows without notice ${r(now.noShowPct)} % of ${now.loadings} loadings${prev ? ` (previous month ${r(prev.noShowPct)} %)` : ''}; the plant's limit is ${LIMIT} %.`,
    cs ? `Příjezd v okně ±30 min: ${r(now.onTimePct)} %, mimo pracovní dobu řidiče ${now.outOfHours}×.`
       : `Arrivals within ±30 min: ${r(now.onTimePct)} %, out of driving hours ${now.outOfHours} times.`,
    now.replyMedian != null && (cs ? `Na urgence odpovídá za ${now.replyMedian} min (medián).` : `Replies to follow-ups in ${now.replyMedian} min (median).`),
    better && (cs ? 'Oproti minulému měsíci se zlepšil; ocenit a udržet trend.' : 'Better than last month; acknowledge it and keep the trend.'),
  ].filter(Boolean);

  const proposals = [
    over && { term: cs ? 'Smluvní pokuta' : 'Contractual penalty', detail: cs ? `Za každé nepřijetí bez avíza nad ${LIMIT} % měsíčně, např. 1 500 Kč.` : `For each no-show without notice above ${LIMIT} % a month, e.g. CZK 1,500.` },
    { term: cs ? 'Avizace do 12:00' : 'Announcement by 12:00', detail: cs ? 'Každé auto potvrdit přes odkaz pro dispečera do 12:00 dne nakládky.' : 'Confirm every truck via the dispatcher link by 12:00 on the loading day.' },
    slow && { term: cs ? 'Odpověď do 30 min' : 'Reply within 30 min', detail: cs ? 'Na urgenci odpovědět do 30 minut, jinak eskalace na hovor.' : 'Reply to a follow-up within 30 minutes, otherwise it escalates to a call.' },
    !over && { term: cs ? 'Přednost ve slotech' : 'Slot priority', detail: cs ? 'Za spolehlivost nabídnout přednost v ranních slotech.' : 'Offer priority in morning slots as a reward for reliability.' },
  ].filter(Boolean);

  return {
    goal: cs
      ? (over ? `Snížit nepřijetí bez avíza u ${name} pod ${LIMIT} % do konce příštího měsíce.` : `Udržet spolehlivost ${name} a domluvit lepší avizaci.`)
      : (over ? `Bring ${name}'s no-shows without notice below ${LIMIT} % by the end of next month.` : `Keep ${name} reliable and agree on better announcements.`),
    arguments: args,
    proposals,
    agreements: cs
      ? ['Kontakt na dispečera pro urgence (jméno, telefon, kanál).', 'Termín další kontroly čísel: za měsíc.']
      : ['Dispatcher contact for follow-ups (name, phone, channel).', 'Next review of the numbers: in one month.'],
  };
}
